import request from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { newGatewayUrl } from '@/constant';
import { SelectCardInfo, UserInformation, UserInfoVo } from './types';

// 选择银行卡列表
export const getSelectCardList = (formData: {
  cardType: number;
  commodityId: string;
  /** 资方code */
  capitalCode?: string;
  /** 订单 id */
  loanOrderId?: string;
  /** 场景：提现、还款 */
  scene?: string;
}): Promise<SelectCardInfo[]> => requestDefault.postGate('f.card.selected.list', formData);

// 获取我的--银行卡列表（包含货币逻辑）
export const getMyBankList = (): Promise<{
  bankCards:SelectCardInfo[],
}> => requestDefault.postGate('f.user.card.findCardWallet');

// 获取用户三要素
export const getUserInfomation = (): Promise<UserInfoVo> => request.postGate<UserInformation>('f.user.three.elements', {}, { baseURL: newGatewayUrl });

const SelectCardApi = {
  getSelectCardList,
  getMyBankList,
  getUserInfomation,
};

export default SelectCardApi;
